export default __webpack_public_path__ + "static/media/techevent.662ffe8f.svg";